import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Form, Input, Spin, Alert, Result, Typography } from "antd";
import { LoadingOutlined, CloseOutlined } from "@ant-design/icons";
import axios from "axios";

const { Title } = Typography;

const CreateDriver = () => {
  const [created, setCreated] = useState(false);
  const [errors, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onSubmit = async (values) => {
    setLoading(true);
    const body = {
      ...values,
      role: "DRIVER",
    };

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/`, body);
      setLoading(false);
      setError(null);
      setCreated(true);
      form.resetFields();
    } catch (error) {
      await setError(error.response.data);
      Object.keys(error.response.data).map((key) => {
        form.setFields([
          {
            name: key,
            errors: [error.response.data[key][0]],
          },
        ]);
      });
      setLoading(false);
    }
  };

  const onFinishFailed = () => {
    console.log("failed");
  };

  return (
    <div className="page create-driver">
      <Link to="/" className="close-page">
        <CloseOutlined
          style={{
            fontSize: 42,
            color: "#333",
          }}
        />
      </Link>
      <div className="wrapper">
        <Title>Создать Водителя</Title>
        {loading && (
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 32,
                }}
                spin
              />
            }
          />
        )}
        {created && (
          <Result
            status="success"
            title="Водитель создан!"
            extra={[
              <Button type="primary" key="console">
                Список водителей
              </Button>,
              <Button key="buy" onClick={() => setCreated(false)}>
                Создать ещё
              </Button>,
            ]}
          />
        )}
        {!created && (
          <Form
            form={form}
            name="basic"
            style={{ maxWidth: 400 }}
            onFinish={onSubmit}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
          >
            {errors &&
              Object.keys(errors).map((key) => {
                return (
                  <div key={key}>
                    <Alert message={errors[key][0]} type="error" showIcon />
                    <br />
                  </div>
                );
              })}
            <Form.Item label="Логин" name="username">
              <Input />
            </Form.Item>
            <Form.Item label="Имя" name="first_name">
              <Input />
            </Form.Item>
            <Form.Item label="Фамилия" name="last_name">
              <Input />
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "Введите правильный email",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Телефон"
              name="phone_number"
              rules={[
                {
                  required: true,
                  message: "Обязательное поле",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Пароль" name="password">
              <Input.Password />
            </Form.Item>
            <Button type="primary" htmlType="submit">
              Создать
            </Button>
          </Form>
        )}
      </div>
    </div>
  );
};

export default CreateDriver;
